import React from "react";
import { Icon } from "@iconify/react";
import DataManagement from "../../components/table/DataManagement.jsx";
import { useNavigate, Link } from "react-router-dom";

import { useTerceros } from "../../hooks_cache/useTerceros.js";

const tipoTerceroColumn = {
  accessorKey: "tipo_tercero",
  header: "Tipo de Tercero",
  cell: ({ row }) => {
    const { es_cliente, es_proveedor } = row.original;
    if (es_cliente && es_proveedor)
      return (
        <>
          <span className="badge bg-green">CLIENTE</span> <span className="badge bg-primary">PROVEEDOR</span>
        </>
      );
    if (es_cliente) return <span className="badge bg-green">CLIENTE</span>;
    if (es_proveedor) return <span className="badge bg-primary">PROVEEDOR</span>;
    return "No Definido";
  },
};

const nombreColumn = {
  accessorKey: "nombre",
  header: "RAZON SOCIAL",
  cell: ({ row }) => {
    const { id, nombre } = row.original;
    return (
      <Link to={`/tercero/${id}`} className="fw-bold text-nowrap">
        {nombre}
      </Link>
    );
  },
};

const columns = [
  { accessorKey: "nrc", header: "NRC" },
  nombreColumn,
  { accessorKey: "nit", header: "NIT" },
  { accessorKey: "correo", header: "CORREO" },
  tipoTerceroColumn,
];

function TercerosTable() {
  const navigate = useNavigate();
  const { data: terceros, refetch } = useTerceros();

  return (
    <DataManagement
      columns={columns}
      data={terceros}
      title="Gestion de terceros"
      actions={[
        <button onClick={() => navigate(`/tercero`)} className="btn btn-primary btn-sm d-flex me-2 pe-3 rounded-3">
          <Icon className="iconify fs-18px me-2 ms-n1" icon="solar:add-circle-bold-duotone" />
          Agregar tercero
        </button>,
        <button onClick={refetch} className="btn btn-theme btn-sm d-flex pe-3 rounded-3">
          <Icon className="iconify fs-18px me-2 ms-n1" icon="solar:refresh-bold-duotone" />
          Refrescar tabla
        </button>,
      ]}
    />
  );
}

export default TercerosTable;
